<template>
	<v-container id="productoscruzaados" tag="section">
		<base-v-component heading="Productos Cruzados del Negocio " />
		<base-material-card
			color="indigo"
			icon="mdi-basket"
			inline
			class="px-5 py-3"
		>
			<v-toolbar flat color="white">
				<v-btn color="success" dark class="mb-2 ml-5" @click="addRegla()"
					>Añadir Regla</v-btn
				>
			</v-toolbar>
			<v-data-table :loading="loading" :items="cruzados" :headers="headers">
				<template v-slot:item.acciones="{ item }">
					<v-card-actions class="pa-0 ma-0">
						<v-spacer></v-spacer>
						<v-tooltip top v-if="item.activo">
							<template v-slot:activator="{ on }">
								<v-btn
									@click="cambiarActivo(item)"
									:loading="loadingActivo"
									class="px-2 ml-1"
									color="green"
									min-width="0"
									v-on="on"
									small
								>
									<v-icon small>mdi-check</v-icon>
								</v-btn>
							</template>
							<span>Desactivar</span>
						</v-tooltip>
						<v-tooltip top v-else>
							<template v-slot:activator="{ on }">
								<v-btn
									@click="cambiarActivo(item)"
									v-on="on"
									class="px-2 ml-1"
									:loading="loadingActivo"
									color="red"
									min-width="0"
									small
								>
									<v-icon small>mdi-close</v-icon>
								</v-btn>
							</template>
							<span>Activar</span>
						</v-tooltip>
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn
									@click="goEdit(item)"
									class="px-2 ml-1"
									color="success"
									min-width="0"
									v-on="on"
									small
								>
									<v-icon small>mdi-pencil</v-icon>
								</v-btn>
							</template>
							<span>Editar</span>
						</v-tooltip>
						<v-btn
							class="px-2 ml-1"
							color="red"
							min-width="0"
							small
							@click="deleteItem(item)"
						>
							<v-icon small>mdi-delete</v-icon>
						</v-btn>
					</v-card-actions>
				</template>
			</v-data-table>
		</base-material-card>
		<v-dialog v-model="formDialog" max-width="800">
			<v-card>
				<v-card-title>{{ formTitle }}</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" md="3" v-if="false">
							<v-text-field label="id" v-model="formObjeto.id" disabled />
						</v-col>
						<v-col cols="12" md="3">
							<v-select
								label="Tipo a ofrecer"
								:items="ofrecerTipoSelect"
								v-model="formObjeto.ofrecerTipo"
								@change="cambioTipo"
							/>
						</v-col>
						<v-col cols="12" md="3">
							<v-select
								label="Prioridad"
								:items="$store.state.cruzados.prioridad"
								v-model="formObjeto.prioridad"
							/>
						</v-col>
						<v-col cols="12" md="3">
							<v-select
								label="Condicion"
								:items="$store.state.cruzados.condicionesTipoSelect"
								v-model="formObjeto.condicionTipo"
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">
							<v-text-field
								label="Descripción"
								v-model="formObjeto.descripcion"
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">
							<v-autocomplete
								:disabled="ofrecerValorLabelDisabled"
								multiple
								:label="ofrecerValorLabel"
								:items="ofrecerValorSelect"
								v-model="formObjeto.ofrecer"
							/>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-btn text color="secondary" @click="formDialog = false"
						>Cancelar</v-btn
					>
					<v-spacer />
					<v-btn @click="addReglaSave" color="primary">Guardar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
	data() {
		return {
			loading: false,
			loadingActivo: false,
			formDialog: false,
			formObjeto: {
				id: null,
				descripcion: "",
				ofrecer: [],
				ofrecerTipo: null,
				condicionTipo: null,
				condicionValor: null,
				prioridad: null,
			},
			headers: [
				{
					text: "Tipo",
					value: "ofrecerTipo",
				},
				{
					text: "Descripción",
					value: "descripcion",
				},
				{
					sortable: false,
					text: "Acciones",
					value: "acciones",
					align: "right",
				},
			],
		};
	},
	watch: {
		formDialog(v) {
			if (!v) {
				this.formObjeto = {
					id: null,
					descripcion: "",
					ofrecer: [],
					ofrecerTipo: null,
					condicionTipo: null,
					condicionValor: null,
				};
			}
		},
	},
	computed: {
		ofrecerValorSelect() {
			return this.formObjeto.ofrecerTipo == "productos"
				? this.$store.getters["productos/getProductosSelect"]
				: this.formObjeto.ofrecerTipo == "categorias"
				? this.$store.getters["categorias/getCategoriasSelect"]
				: [];
		},
		ofrecerValorLabel() {
			return this.formObjeto.ofrecerTipo == "productos"
				? "Elige productos"
				: this.formObjeto.ofrecerTipo == "categorias"
				? "Elige categorías"
				: "Elija un tipo";
		},
		ofrecerValorLabelDisabled() {
			return this.ofrecerValorLabel == "Elija un tipo";
		},
		...mapState({
			cruzados: (state) => state.cruzados.cruzados,
			ofrecerTipoSelect: (state) => state.cruzados.ofrecerTipoSelect,
		}),
		formTitle() {
			return this.formObjeto.id
				? "Editar Regla " + this.formObjeto.id
				: "Añadir Regla";
		},
	},
	methods: {
		goEdit(item) {
			this.formObjeto = item;
			this.formDialog = true;
		},
		cambiarActivo(item) {
			var _vm = this;
			_vm.loadingActivo = true;
			this.$store
				.dispatch("cruzados/changeActivo", {
					id: item.id,
					activo: !(item.activo ? item.activo : false),
				})
				.then((res) => {
					_vm.$store.commit("snackbar/setMensajeSuccess", {
						msj: "Regla grabada con éxito",
					});
					return _vm.getCruzados();
				})
				.catch((error) => {
					console.log(error);
					_vm.$store.commit("snackbar/setMensajeDanger", {
						msj: "Error al guardar la regla",
					});
				})
				.finally(() => {
					_vm.loadingActivo = false;
				});
		},
		cambioTipo() {
			this.formObjeto.ofrecer = [];
		},
		getCruzados() {
			this.loading = true;
			this.$store
				.dispatch("cruzados/getCruzados")
				.finally(() => (this.loading = false));
		},
		save() {},
		addRegla() {
			this.formDialog = true;
		},
		addReglaSave() {
			this.$store
				.dispatch("cruzados/addCruzado", this.formObjeto)
				.then((res) => {
					this.$store.commit("snackbar/setMensajeSuccess", {
						msj: "Regla grabada con éxito",
					});
					this.formDialog = false;
				})
				.catch((error) => {
					console.log(error);
					this.$store.commit("snackbar/setMensajeDanger", {
						msj: "Error al guardar la regla",
					});
				})
				.finally(() => {
					return this.getCruzados();
				});
		},
	},
	mounted() {
		this.getCruzados();
	},
};
</script>

<style>
</style>